import { render, staticRenderFns } from "./CoozzyNavigationSidebar.vue?vue&type=template&id=0c2c8bf5&scoped=true"
import script from "./CoozzyNavigationSidebar.vue?vue&type=script&lang=js"
export * from "./CoozzyNavigationSidebar.vue?vue&type=script&lang=js"
import style0 from "./CoozzyNavigationSidebar.vue?vue&type=style&index=0&id=0c2c8bf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2c8bf5",
  null
  
)

export default component.exports